import { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
import { selectSelectedBenchmark } from "../store/selectors/entitySelectors";
import type { RankingDataSchema } from "../types/api.types";

import type { ChartDataSchema, StructuredChartDataSchema } from "./types";

const useRankingData = (data: RankingDataSchema, isDifferenceSelected: boolean) => {
    const selectedBenchmark = useSelector(selectSelectedBenchmark);

    const [chartData, setChartData] = useState<ChartDataSchema>();
    const [diffChartData, setDiffChartData] = useState<Array<StructuredChartDataSchema>>();

    useEffect(() => {
        if (data) {
            const primaryDomain = selectedBenchmark?.primaryDomains[0];
            const dates = data.primaryData?.absoluteTrend.map((item) => item.key);

            const primaryEntityData = data.primaryData?.absoluteTrend.map((item) => ({
                y: item.value.value,
                diff: item.value.change,
            }));
            const competitorsData = data.competitorsAverageAbsoluteTrend?.map((item) => ({
                y: item.value.value,
                diff: item.value.change,
            }));

            const structuredChartData: StructuredChartDataSchema[] = [
                {
                    name: primaryDomain ?? "",
                    data: primaryEntityData ?? [],
                    color: colorsPalettes.blue[500],
                },
                {
                    name: translate("bt.metrics.ranking.competitors.avg"),
                    data: competitorsData ?? [],
                    color: colorsPalettes.blue[200],
                },
            ];

            setChartData({ structuredChartData, dates });
        }
    }, [data, selectedBenchmark]);

    useEffect(() => {
        if (isDifferenceSelected && data && !diffChartData) {
            const primaryDomain = selectedBenchmark?.primaryDomains[0];

            const diffCompetitors = data.competitorsPrimaryRatioTrend?.map((item) => ({
                y: +item.value,
            }));

            const diffStructuredChartDataMock: StructuredChartDataSchema[] = [
                {
                    name: primaryDomain ?? "",
                    data: diffCompetitors ?? [],
                    color: colorsPalettes.blue[500],
                },
            ];

            setDiffChartData(diffStructuredChartDataMock);
        }
    }, [isDifferenceSelected, data, diffChartData, selectedBenchmark?.primaryDomains]);

    return {
        chartData,
        diffChartData,
    };
};

export default useRankingData;
